<ng-container *ngIf="offer">
  <mat-accordion [multi]="true" displayMode="flat" class="accordion-container">

    <!-- Offer data / External insurer -->
    <mat-expansion-panel [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          <span class="panel-title-text">{{'offer.data' | translate}}</span>
          <span *ngIf="isChanged('offerData')" class="section-changed-badge">
            {{'offer.versionHistory.changed' | translate}}
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <!-- External coverage -->
      <ng-container *ngIf="offer.offerType === OfferType.EXTERNAL_COVERAGE">
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'offer.name' | translate}}:</div>
          <div>{{offer.externalInsurer?.name}}</div>
        </div>
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'offer.streetAndNumber' | translate}}:</div>
          <div>{{offer.externalInsurer?.streetName}} {{offer.externalInsurer?.houseNumber}}</div>
        </div>
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'offer.postalCodeAndLocation' | translate}}:</div>
          <div>{{offer.externalInsurer?.postalCode}} {{offer.externalInsurer?.location}}</div>
        </div>
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'proposalDetails.lkz' | translate}}, {{'proposalDetails.country' | translate}}:</div>
          <div>{{offer.externalInsurer?.countryCode}}, {{'countryCodes.' + offer.externalInsurer?.countryCode | translate}}</div>
        </div>
      </ng-container>

      <!-- Internal offer -->
      <ng-container *ngIf="offer.offerType !== OfferType.EXTERNAL_COVERAGE">
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'offer.name' | translate}}:</div>
          <div>{{offer.creator?.company?.name}}</div>
        </div>
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'offer.streetAndNumber' | translate}}:</div>
          <div>{{offer.creator?.company?.street}} {{offer.creator?.company?.houseNumber}}</div>
        </div>
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'offer.postalCodeAndLocation' | translate}}:</div>
          <div>{{offer.creator?.company?.postalCode}} {{offer.creator?.company?.location}}</div>
        </div>
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'proposalDetails.lkz' | translate}}, {{'proposalDetails.country' | translate}}:</div>
          <div>{{offer.creator?.company?.countryCode}}, {{'countryCodes.' + offer.creator?.company?.countryCode | translate}}</div>
        </div>
      </ng-container>
    </mat-expansion-panel>

    <!-- Contact person (internal offers only) -->
    <ng-container *ngIf="offer.offerType !== OfferType.EXTERNAL_COVERAGE">
      <hr>
      <mat-expansion-panel [togglePosition]="'before'">
        <mat-expansion-panel-header [@.disabled]="true">
          <mat-panel-title>
            <span class="panel-title-text">{{'offer.contactPerson' | translate}}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'offer.name' | translate}}:</div>
          <div>{{offer.creator?.lastName}}, {{offer.creator?.firstName}}</div>
        </div>
        <div class="d-flex proposal-details-row" *ngIf="offer.creator?.phoneNumber">
          <div class="info-col">{{'offer.phoneNumber' | translate}}:</div>
          <div>{{offer.creator?.phoneNumber}}</div>
        </div>
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'offer.mobile' | translate}}:</div>
          <div>{{offer.creator?.mobileNumber}}</div>
        </div>
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'offer.email' | translate}}:</div>
          <div>{{offer.creator?.email}}</div>
        </div>
      </mat-expansion-panel>
    </ng-container>

    <hr>
    <!-- Management / Business -->
    <mat-expansion-panel [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          <span class="panel-title-text">{{'offer.managementBusiness' | translate}}</span>
          <span *ngIf="isChanged('management')" class="section-changed-badge">
            {{'offer.versionHistory.changed' | translate}}
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="d-flex proposal-details-row">
        <div class="info-col">{{'offer.role' | translate}}:</div>
        <div>{{(offer.isLeading ? 'offer.leadInsurer' : 'offer.followingInsurer') | translate}}</div>
      </div>
      <div class="d-flex proposal-details-row">
        <div class="info-col">{{'offer.share' | translate}} ({{'offer.inPercent' | translate}}):</div>
        <div>{{offer.amountCovered | percent:'1.2-2'}}</div>
      </div>
    </mat-expansion-panel>

    <hr>
    <!-- Premium -->
    <mat-expansion-panel [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          <span class="panel-title-text">{{'offer.premium' | translate}}</span>
          <span *ngIf="isChanged('premium')" class="section-changed-badge">
            {{'offer.versionHistory.changed' | translate}}
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="d-flex proposal-details-row">
        <div class="info-col">{{'offer.createOffer.referenceValue' | translate}}:</div>
        <div *ngIf="offer.referenceValue">{{'proposalDetails.createOfferTab.referenceValues.' + offer.referenceValue | translate}}</div>
      </div>
      <div *ngIf="offer.premiumInPercent != 0" class="d-flex proposal-details-row">
        <div class="info-col">{{'offer.inPercent' | translate}}:</div>
        <div>{{offer.premiumInPercent | percent:'1.2-2'}}</div>
      </div>
      <div *ngIf="offer.premiumPerThousand != 0" class="d-flex proposal-details-row">
        <div class="info-col">{{'offer.perThousand' | translate}}:</div>
        <div>{{offer.premiumPerThousand | permilleFormat}}</div>
      </div>
      <div class="d-flex proposal-details-row">
        <div class="info-col">{{'offer.premium' | translate}}:</div>
        <div>{{offer.premium | currency:offer.currency}}</div>
      </div>
      <div class="d-flex proposal-details-row">
        <div class="info-col">{{'offer.expectedTotalPremium' | translate}}:</div>
        <div>{{offer.expectedTotalPremium | currency:offer.currency}}</div>
      </div>
      <div class="d-flex proposal-details-row" *ngIf="offer.advancePremium">
        <div class="info-col">{{'offer.advancePremium' | translate}}:</div>
        <div>{{offer.advancePremium | currency:offer.currency}}</div>
      </div>
      <div class="d-flex proposal-details-row" *ngIf="offer.minimumPremium">
        <div class="info-col">{{'offer.minimumPremium' | translate}}:</div>
        <div>{{offer.minimumPremium | currency:offer.currency}}</div>
      </div>
      <div class="d-flex proposal-details-row">
        <div class="info-col">{{'proposalDetails.createOfferTab.typeOfDeductible' | translate}}:</div>
        <div *ngIf="offer.typeOfDeductible">{{'proposalDetails.createOfferTab.typeOfDeductibleOptions.' + offer.typeOfDeductible | translate}}</div>
      </div>
      <div *ngIf="offer.deductibleAbsoluteAmount" class="d-flex proposal-details-row">
        <div class="info-col">{{'proposalDetails.createOfferTab.deductibleAbsoluteAmount' | translate}}:</div>
        <div>{{offer.deductibleAbsoluteAmount | currency:offer.deductibleCurrency}}</div>
      </div>
    </mat-expansion-panel>

    <ng-container *ngIf="offer.offerType !== OfferType.EXTERNAL_COVERAGE">
      <hr>
      <!-- Default terms -->
      <mat-expansion-panel [disabled]="offer.standardTermsAndConditions?.length == 0" [togglePosition]="'before'">
        <mat-expansion-panel-header [@.disabled]="true">
          <mat-panel-title>
            <span class="panel-title-text">{{'offer.defaultTerms' | translate}}</span>
            <span *ngIf="isChanged('defaultTerms')" class="section-changed-badge">
              {{'offer.versionHistory.changed' | translate}}
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="pre-wrap">- {{offer.standardTermsAndConditions?.join('\n - ')}}</div>
      </mat-expansion-panel>

      <hr>
      <!-- Individual terms -->
      <mat-expansion-panel [disabled]="!offer.individualTermsAndConditions" [togglePosition]="'before'">
        <mat-expansion-panel-header [@.disabled]="true">
          <mat-panel-title>
            <span class="panel-title-text">{{'offer.individualTerms' | translate}}</span>
            <span *ngIf="isChanged('individualTerms')" class="section-changed-badge">
              {{'offer.versionHistory.changed' | translate}}
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="pre-wrap">{{offer.individualTermsAndConditions}}</div>
      </mat-expansion-panel>

      <hr>
      <!-- Default clauses -->
      <mat-expansion-panel [disabled]="offer.standardClauses?.length == 0" [togglePosition]="'before'">
        <mat-expansion-panel-header [@.disabled]="true">
          <mat-panel-title>
            <span class="panel-title-text">{{'offer.defaultClauses' | translate}}</span>
            <span *ngIf="isChanged('defaultClauses')" class="section-changed-badge">
              {{'offer.versionHistory.changed' | translate}}
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="pre-wrap">- {{offer.standardClauses?.join('\n - ')}}</div>
      </mat-expansion-panel>

      <hr>
      <!-- Individual clauses -->
      <mat-expansion-panel [disabled]="!offer.individualClauses" [togglePosition]="'before'">
        <mat-expansion-panel-header [@.disabled]="true">
          <mat-panel-title>
            <span class="panel-title-text">{{'offer.individualClauses' | translate}}</span>
            <span *ngIf="isChanged('individualClauses')" class="section-changed-badge">
              {{'offer.versionHistory.changed' | translate}}
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="pre-wrap">{{offer.individualClauses}}</div>
      </mat-expansion-panel>

      <hr>
      <!-- Other information -->
      <mat-expansion-panel [disabled]="!offer.otherInformation" [togglePosition]="'before'">
        <mat-expansion-panel-header [@.disabled]="true">
          <mat-panel-title>
            <span class="panel-title-text">{{'offer.createOffer.individualInformationSection.otherInformation' | translate}}</span>
            <span *ngIf="isChanged('otherInformation')" class="section-changed-badge">
              {{'offer.versionHistory.changed' | translate}}
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="pre-wrap">{{offer.otherInformation}}</div>
      </mat-expansion-panel>
    </ng-container>

    <hr>
    <!-- Files -->
    <mat-expansion-panel [disabled]="offer.attachedFiles?.length === 0" [togglePosition]="'before'" class="mb-4">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          <span class="panel-title-text">{{'offer.files' | translate}}</span>
          <span *ngIf="isChanged('files')" class="section-changed-badge">
            {{'offer.versionHistory.changed' | translate}}
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-version-history-files
        [attachedFiles]="offer.attachedFiles"
        [existingFileIds]="existingFileIds"></app-version-history-files>
    </mat-expansion-panel>

  </mat-accordion>
</ng-container>
